<template>
  <Modal :open="open" size="small" @close="$emit('close')">
    <h2 class="text-lg font-bold text-gray-900 mb-4">{{ t("title") }}</h2>
    <p class="text-sm text-gray-500 mb-6">{{ t("description") }}</p>

    <div class="space-y-4">
      <FileField id="file" :formData="formData" :placeholder="t('select_file')" accept=".xlsx" @files="onFileChange" />

      <div class="flex justify-end gap-3 pt-2">
        <button
          class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50"
          @click="$emit('close')"
        >
          {{ t("cancel") }}
        </button>
        <button
          class="px-4 py-2 text-sm font-medium text-white bg-primary rounded-lg hover:bg-primary-dark"
          :disabled="!hasFile || isUploading"
          @click="uploadFile"
        >
          <span v-if="isUploading" class="flex items-center gap-2">
            <svg class="animate-spin h-4 w-4" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" fill="none" />
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
            {{ t("uploading") }}
          </span>
          <span v-else>{{ t("upload_button") }}</span>
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { useI18n } from "vue-i18n";
import { Modal, FileField } from "@estaly/ui";
import { mapActions, mapState } from "vuex";

export default {
  components: { Modal, FileField },

  props: {
    open: { type: Boolean, required: true },
  },

  emits: ["close"],

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return {
      formData: new FormData(),
      hasFile: false,
      isUploading: false,
    };
  },

  computed: {
    ...mapState("auth", ["currentUser"]),
  },

  methods: {
    ...mapActions("grossSales", ["importFile"]),

    onFileChange() {
      this.hasFile = this.formData.has("file");
    },

    async uploadFile() {
      if (!this.hasFile) return;

      this.isUploading = true;
      const organizationId = this.currentUser.organization.id;
      const file = this.formData.get("file");
      const response = await this.importFile({ organizationId, file });
      this.isUploading = false;

      if (response?.success) {
        this.$store.dispatch("notifications/notify", {
          type: "success",
          category: "simple",
          title: this.t("success_title"),
          text: this.t("success_message"),
        });
        this.$emit("close");
        this.formData = new FormData();
        this.hasFile = false;
      } else {
        this.$store.dispatch("notifications/notify", {
          type: "error",
          category: "simple",
          title: this.t("error_title"),
          text: this.t("error_message"),
        });
      }
    },
  },
};
</script>

<i18n src="./GrossSalesImportModal.i18n.json"></i18n>
